import React, { useState } from "react";
import { useNavigate } from "react-router";
import { loginAsync } from "../api/auth";
import styles from "./login.module.css";

export default function Login({ onAuth }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);

    try {
      const response = await loginAsync(login.trim(), password);
      if (!response.ok)
        throw new Error(response.status === 403
          ? "Неверный логин или пароль"
          : "Сервис авторизации временно недоступен");

      const result = await response.json();
      if (!result.jwtToken)
        throw new Error("Сервис вернул некорректный ответ");

      onAuth(result.jwtToken);
      navigate("/work");
    } catch (requestError) {
      console.error(requestError);
      setError(requestError.message || "Не получилось войти");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>

        <h2 className={styles.title}>Вход</h2>

        <form onSubmit={onSubmit} className={styles.form}>
          
          <div className={styles.group}>
            <label className={styles.label}>Телефон или email</label>
            <input
              type="text"
              placeholder="Введите телефон или email"
              value={login}
              onChange={(e) => setLogin(e.target.value)}
              className={styles.input}
              autoComplete="username"
              required
            />
          </div>

          <div className={styles.group}>
            <label className={styles.label}>Пароль</label>
            <input
              type="password"
              placeholder="Введите пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div className={styles.error} role="alert">{error}</div>}

          <button type="submit" className={styles.button} disabled={isSubmitting}>
            {isSubmitting ? "Вход…" : "Войти"}
          </button>

        </form>

      </div>
    </div>
  );
}
